import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { IconChevronRight } from 'components/Icons'

interface Props extends HTMLAttributes<HTMLButtonElement> {}

const ButtonKbpayLiveCancel: React.FC<Props> = (props) => {
  return (
    <StyledButton type={'button'} {...props}>
      {'Live 쇼핑 이용 해지'}
      <IconChevronRight />
    </StyledButton>
  )
}

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  min-width: 110px;
  height: 16px;
  border: none;
  color: #999999 !important;
  background: none;
  font-size: 12px;
  cursor: pointer;
`
export default ButtonKbpayLiveCancel
